export const MODULATOR_APPLIANCES_TABLE_CARD_FRENCH_LOCALE = {
  title: "Appareils",
  searchPlaceholder: "Rechercher une valeur...",
  table: {
    headers: {
      way: "Voie",
      csId: "Id CS",
      hwId: "Id Hardware",
      applianceType: "Type d'appareil",
      location: "Localisation",
    },
    empty: "Aucun appareil n'a été trouvé",
  },
};
